<template>
  <div class="menu-shelf__linklist">
    <ul class="menu-shelf__linklist-wrapper">
      <li class="menu-shelf__linklist-item">
        <p
          class="menu-shelf__linklist-title text-label-s"
          v-text="linklist.title"
        />
      </li>

      <li
        v-for="(link, index) in linklist.links"
        :key="index"
        class="menu-shelf__linklist-item"
      >
        <a
          class="text-body-xs menu-shelf__linklist-link"
          :href="getLocalisedUrl(link.localisedUrl || link.url)"
          v-text="link.title"
        />
      </li>
    </ul>
  </div>
</template>

<script>

/**
 * Vue: Menu shelf linklist
 * -----------------------------------------------------------------------------
 * Abstracts away rendering of repeated linklists into a separate component
 * @param {Object} linklist - A single linklist object.
 *
 */
import { getLocalisedRoute } from '~/helpers/routes'

export default {
  name: 'MenuShelfLinkList',

  props: {
    linklist: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    getLocalisedUrl(url) {
      return getLocalisedRoute(url)
    },
  },
}
</script>
